function isDate(value) {
    return value instanceof Date;
}

export { isDate };
